import React from 'react';

import './TransferRecruiter.css';
import Modal from '../../UI/Modal/Modal';
import Textbox from '../../UI/Textbox/Textbox';
import Button from '../../UI/Button/Button';
import closeIcon from '../../../assets/images/remove-close.svg';
import { Table } from 'react-bootstrap';
import Checkbox from '../../UI/Checkbox/Checkbox';
import moment from 'moment';
// import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc Transfer recruiter's job to another recruiter(Modal)
* @version 0.1.0
* @author Jamshith
*/

const TransferRecruiter = (props) => {
  const bhId =  (props.recruiterDetails.userBhId && props.recruiterDetails.userBhId !== null)? "(" + props.recruiterDetails.userBhId + ")" :  "";
  //ConsoleLog("TransferRecruiter",props.allJobCheck,props.transferingJoblist)
    return(
      <Modal show={props.showTransferRecruiterModal} className="transfer-recruiter-modal" backdropClassName="transfer-recruiter-backdrop">
        <div className="transfer-recruiter-modal-header">Transfer
          <span className="close-transfer-icon" onClick={props.closeTransferModal}><img src={closeIcon} alt="close this" /></span>
        </div>
        <div className="transfer-recruiter-modal-jobheadline">You are about to transfer  
          <span className="transfer-rec-basic-info">
            {" " + props.recruiterDetails.firstName + " " + props.recruiterDetails.lastName + "'s " + bhId } 
          </span> jobs and candidates
        </div>
        <div className="transfer-recruiter-modal-jobheadinfo">Please select the jobs to transfer</div>
        <div className="rec-tfr-wrapper">
          <Table striped condensed hover className="admin-rec-joblist-container-tbl">
          <thead className="admin-rec-joblist-container-head">
            <tr className="admin-rec-joblist-container-tr-head">
              <th className="checkbox">
                <Checkbox
                  checked={(props.allJobCheck && (props.transferingJoblist.length>0 && props.transferingJoblist.length === props.joblist.length))?true:false} 
                  onClick={(event) => props.handleAllJobCheck(event)}
                />
              </th>
              <th className="dateAdded">Date Added</th>
              <th className="bullhornId">Bullhorn Job ID</th>
              <th className="jobTitle">Job Title</th>
              <th className="company">Company</th>
            </tr>
          </thead>
          <tbody className="admin-rec-joblist-container-tblbody">
            {(props.joblist.length > 0) ? 
                props.joblist.map((job, index) => (
                  <tr className="admin-rec-joblist-container-trbody">
                    <td className="checkbox">
                      <Checkbox
                        id="select-job"
                        checked={props.transferingJoblist.includes(job.jobid)?true:false} 
                        onClick={(event) => props.handleJobCheck(event,job)}
                      />
                    </td>
                    <td className="dateAdded">{moment(job.dateadded).format("DD/MM/YYYY")}</td>
                    <td className="bullhornId">{job.jobbhid}</td>
                    <td className="jobTitle">{job.jobtitle}</td>
                    <td className="company">{job.company}</td>
                  </tr>
                ))
              : 
              <React.Fragment>
                <tr className="admin-rec-joblist-container-trbody rec-joblist-transfer-no-jobs-info">
                  <span className="noresults">There are no jobs under this recruiter to transfer</span>
                </tr>
              </React.Fragment>
            }
          </tbody>
        </Table>
        </div>
        <div className="rec-transfer-footer">
          <Textbox 
            id="email" 
            className={(props.errorPosition.includes("transferEmailEmpty")) ? "rec-email-transfer "+"invalid-input" : 
              (props.errorPosition.includes("transferEmailFormat")) ? "rec-email-transfer "+"invalid-input" : "rec-email-transfer "+""}
            label="Email/ID" 
            placeholder="Enter Email/ID" 
            value={props.recJobTransferToEmail} 
            onChange={(event) => props.handleTransferEmailIdChange(event)}
          > 
          <p className="error-message">{(props.errorPosition.includes("transferEmailEmpty")) ? "Please enter Email" :
          props.errorPosition.includes("transferEmailFormat") ? "Please enter a valid mail address" :
          props.errorPosition.includes("UserExists")?"User already exists":
          props.errorPosition.includes("UserNotExists")?"User does not exist":""}</p>
        </Textbox>
        <Button className="rec-transfer-button" onClick={props.SubmitTransfer} disabled={props.disableTransferButton || props.transferingJoblist.length === 0}>Transfer</Button>
      </div>
      </Modal>
    );
  }
  
  export default TransferRecruiter;


// WEBPACK FOOTER //
// ./src/components/Admin/TransferRecruiter/TransferRecruiter.js